export const ADMIN = {
    loginRoot: 'admin-login-root',
    dashboardRoot: 'admin-dashboard-root',
    logoutButton: 'admin-logout-button',
    sectorFilter: 'admin-sector-filter',
    statusFilter: 'admin-status-filter',
    searchInput: 'admin-search-input',
    exportButton: 'admin-export-button',
    refreshButton: 'admin-refresh-button',
    enquiriesTable: 'admin-enquiries-table',
    row: (id) => `admin-enquiry-row-${id}`,
    statCard: (key) => `admin-stat-card-${key}`,
    detailDialog: 'admin-enquiry-detail-dialog',
    statusUpdate: 'admin-status-update-select',
    notesInput: 'admin-notes-input',
    saveButton: 'admin-save-button',
    deleteButton: 'admin-delete-button',
};
